/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ListItemTypeEnum = "containers" | "external_contacts" | "internal_contacts" | "item" | "messages" | "shipments" | "tickets" | "vessels" | "voyages" | "%future added value";
export type FilterInput = {
    key: string;
    values: Array<string>;
};
export type RelatedItemListQueryVariables = {
    searchQuery?: string | null;
    type?: ListItemTypeEnum | null;
    parentAbsoluteSlug?: string | null;
    contactSlug?: string | null;
    filters?: Array<FilterInput> | null;
    includeArchived?: boolean | null;
    sortKey?: string | null;
    page?: number | null;
    perPage?: number | null;
    handoverDateStart?: string | null;
    handoverDateEnd?: string | null;
    voyageEtaStart?: string | null;
    voyageEtaEnd?: string | null;
    voyageEtdStart?: string | null;
    voyageEtdEnd?: string | null;
    dischargeDateStart?: string | null;
    dischargeDateEnd?: string | null;
    requiredPagination?: boolean | null;
    sharedContactType?: string | null;
};
export type RelatedItemListQueryResponse = {
    readonly itemList: {
        readonly sortKeys: ReadonlyArray<{
            readonly key: string;
            readonly title: string;
        }>;
        readonly totalCount: number | null;
        readonly downloadToken: string;
        readonly " $fragmentRefs": FragmentRefs<"ItemListFooter_data" | "RelatedItemListContent_data">;
    };
};
export type RelatedItemListQuery = {
    readonly response: RelatedItemListQueryResponse;
    readonly variables: RelatedItemListQueryVariables;
};



/*
query RelatedItemListQuery(
  $searchQuery: String
  $type: ListItemTypeEnum
  $parentAbsoluteSlug: String
  $contactSlug: String
  $filters: [FilterInput!]
  $includeArchived: Boolean
  $sortKey: String
  $page: Int
  $perPage: Int
  $handoverDateStart: Date
  $handoverDateEnd: Date
  $voyageEtaStart: Date
  $voyageEtaEnd: Date
  $voyageEtdStart: Date
  $voyageEtdEnd: Date
  $dischargeDateStart: Date
  $dischargeDateEnd: Date
  $requiredPagination: Boolean
  $sharedContactType: String
) {
  itemList(searchQuery: $searchQuery, type: $type, parentAbsoluteSlug: $parentAbsoluteSlug, contactSlug: $contactSlug, filters: $filters, includeArchived: $includeArchived, sortKey: $sortKey, page: $page, perPage: $perPage, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, requiredPagination: $requiredPagination, sharedContactType: $sharedContactType) {
    ...ItemListFooter_data
    ...RelatedItemListContent_data
    sortKeys {
      key
      title
    }
    totalCount
    downloadToken
  }
}

fragment Badge_data on Badge {
  type
}

fragment ContactLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  imageUrl
}

fragment ContainerLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  badge {
    ...Badge_data
  }
}

fragment ItemImage_data on Image {
  url
  alt
  highlight
  shape
  overlay
  overlayIcon
}

fragment ItemListFooter_data on ItemList {
  paginationMeta {
    hasNextPage
    hasPrevPage
    page
    perPage
    totalPages
  }
}

fragment KeyField_data on KeyField {
  label
  value {
    key
    ...SemanticString_data
  }
}

fragment LinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  entitySlug
  ...VoyageLinkCard_data
  ...VesselLinkCard_data
  ...ShipmentLinkCard_data
  ...ContainerLinkCard_data
  ...ContactLinkCard_data
}

fragment LinkSet_data on LinkSet {
  title
  inline
  links {
    key
    type
    ...LinkCard_data
  }
}

fragment RelatedItemListContent_data on ItemList {
  items {
    edges {
      node {
        slug
        ...ShowPageListItem_listItem
        id
      }
    }
  }
  downloadToken
}

fragment SemanticLine_data on SemanticLine {
  parts {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}

fragment ShipmentLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  badge {
    ...Badge_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
}

fragment ShowPageListItem_listItem on ListItem {
  slug
  title
  isArchived
  itemType
  stickyNoteContent
  image {
    ...ItemImage_data
  }
  path
  statuses {
    key
    value {
      ...SemanticString_data
    }
  }
  stages {
    key
    status
    label
    value
  }
  badges {
    key
    ...Badge_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  linkSets {
    key
    ...LinkSet_data
  }
  keyFields {
    key
    ...KeyField_data
  }
  children {
    slug
    title
    itemType
    badges {
      key
      ...Badge_data
    }
    id
  }
}

fragment VesselLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
}

fragment VoyageLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  voyageEta {
    ...SemanticString_data
  }
  voyageEtd {
    ...SemanticString_data
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateEnd"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateStart"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handoverDateEnd"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handoverDateStart"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentAbsoluteSlug"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perPage"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredPagination"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sharedContactType"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortKey"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaEnd"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaStart"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdEnd"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdStart"
},
v19 = [
  {
    "kind": "Variable",
    "name": "contactSlug",
    "variableName": "contactSlug"
  },
  {
    "kind": "Variable",
    "name": "dischargeDateEnd",
    "variableName": "dischargeDateEnd"
  },
  {
    "kind": "Variable",
    "name": "dischargeDateStart",
    "variableName": "dischargeDateStart"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "handoverDateEnd",
    "variableName": "handoverDateEnd"
  },
  {
    "kind": "Variable",
    "name": "handoverDateStart",
    "variableName": "handoverDateStart"
  },
  {
    "kind": "Variable",
    "name": "includeArchived",
    "variableName": "includeArchived"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "parentAbsoluteSlug",
    "variableName": "parentAbsoluteSlug"
  },
  {
    "kind": "Variable",
    "name": "perPage",
    "variableName": "perPage"
  },
  {
    "kind": "Variable",
    "name": "requiredPagination",
    "variableName": "requiredPagination"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  },
  {
    "kind": "Variable",
    "name": "sharedContactType",
    "variableName": "sharedContactType"
  },
  {
    "kind": "Variable",
    "name": "sortKey",
    "variableName": "sortKey"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaEnd",
    "variableName": "voyageEtaEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaStart",
    "variableName": "voyageEtaStart"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdEnd",
    "variableName": "voyageEtdEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdStart",
    "variableName": "voyageEtdStart"
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "SortKey",
  "kind": "LinkedField",
  "name": "sortKeys",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "downloadToken",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemType",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v28 = [
  (v27/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badges",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v32 = [
  (v20/*: any*/),
  (v27/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "SemanticLine",
  "kind": "LinkedField",
  "name": "lines",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SemanticString",
      "kind": "LinkedField",
      "name": "parts",
      "plural": true,
      "selections": (v32/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RelatedItemListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "ItemList",
        "kind": "LinkedField",
        "name": "itemList",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ItemListFooter_data"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RelatedItemListContent_data"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v11/*: any*/),
      (v14/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v13/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v16/*: any*/),
      (v15/*: any*/),
      (v18/*: any*/),
      (v17/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Operation",
    "name": "RelatedItemListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "ItemList",
        "kind": "LinkedField",
        "name": "itemList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Paginate",
            "kind": "LinkedField",
            "name": "paginationMeta",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPrevPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "page",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "perPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPages",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ListItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ListItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ListItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isArchived",
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stickyNoteContent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "alt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highlight",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shape",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "overlay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "overlayIcon",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "path",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Status",
                        "kind": "LinkedField",
                        "name": "statuses",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SemanticString",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": (v28/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stage",
                        "kind": "LinkedField",
                        "name": "stages",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v31/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkSet",
                        "kind": "LinkedField",
                        "name": "linkSets",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Link",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "meta",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageUrl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "entitySlug",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "voyageEta",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SemanticString",
                                "kind": "LinkedField",
                                "name": "voyageEtd",
                                "plural": false,
                                "selections": (v28/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Badge",
                                "kind": "LinkedField",
                                "name": "badge",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "KeyField",
                        "kind": "LinkedField",
                        "name": "keyFields",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SemanticString",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": (v32/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ListItem",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          (v21/*: any*/),
                          (v26/*: any*/),
                          (v31/*: any*/),
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v24/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3de5bb6de8e96acaf4ee30d4e66ca35c",
    "id": null,
    "metadata": {},
    "name": "RelatedItemListQuery",
    "operationKind": "query",
    "text": "query RelatedItemListQuery(\n  $searchQuery: String\n  $type: ListItemTypeEnum\n  $parentAbsoluteSlug: String\n  $contactSlug: String\n  $filters: [FilterInput!]\n  $includeArchived: Boolean\n  $sortKey: String\n  $page: Int\n  $perPage: Int\n  $handoverDateStart: Date\n  $handoverDateEnd: Date\n  $voyageEtaStart: Date\n  $voyageEtaEnd: Date\n  $voyageEtdStart: Date\n  $voyageEtdEnd: Date\n  $dischargeDateStart: Date\n  $dischargeDateEnd: Date\n  $requiredPagination: Boolean\n  $sharedContactType: String\n) {\n  itemList(searchQuery: $searchQuery, type: $type, parentAbsoluteSlug: $parentAbsoluteSlug, contactSlug: $contactSlug, filters: $filters, includeArchived: $includeArchived, sortKey: $sortKey, page: $page, perPage: $perPage, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, requiredPagination: $requiredPagination, sharedContactType: $sharedContactType) {\n    ...ItemListFooter_data\n    ...RelatedItemListContent_data\n    sortKeys {\n      key\n      title\n    }\n    totalCount\n    downloadToken\n  }\n}\n\nfragment Badge_data on Badge {\n  type\n}\n\nfragment ContactLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  imageUrl\n}\n\nfragment ContainerLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  badge {\n    ...Badge_data\n  }\n}\n\nfragment ItemImage_data on Image {\n  url\n  alt\n  highlight\n  shape\n  overlay\n  overlayIcon\n}\n\nfragment ItemListFooter_data on ItemList {\n  paginationMeta {\n    hasNextPage\n    hasPrevPage\n    page\n    perPage\n    totalPages\n  }\n}\n\nfragment KeyField_data on KeyField {\n  label\n  value {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment LinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  entitySlug\n  ...VoyageLinkCard_data\n  ...VesselLinkCard_data\n  ...ShipmentLinkCard_data\n  ...ContainerLinkCard_data\n  ...ContactLinkCard_data\n}\n\nfragment LinkSet_data on LinkSet {\n  title\n  inline\n  links {\n    key\n    type\n    ...LinkCard_data\n  }\n}\n\nfragment RelatedItemListContent_data on ItemList {\n  items {\n    edges {\n      node {\n        slug\n        ...ShowPageListItem_listItem\n        id\n      }\n    }\n  }\n  downloadToken\n}\n\nfragment SemanticLine_data on SemanticLine {\n  parts {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n\nfragment ShipmentLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  badge {\n    ...Badge_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n}\n\nfragment ShowPageListItem_listItem on ListItem {\n  slug\n  title\n  isArchived\n  itemType\n  stickyNoteContent\n  image {\n    ...ItemImage_data\n  }\n  path\n  statuses {\n    key\n    value {\n      ...SemanticString_data\n    }\n  }\n  stages {\n    key\n    status\n    label\n    value\n  }\n  badges {\n    key\n    ...Badge_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  linkSets {\n    key\n    ...LinkSet_data\n  }\n  keyFields {\n    key\n    ...KeyField_data\n  }\n  children {\n    slug\n    title\n    itemType\n    badges {\n      key\n      ...Badge_data\n    }\n    id\n  }\n}\n\nfragment VesselLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n}\n\nfragment VoyageLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  voyageEta {\n    ...SemanticString_data\n  }\n  voyageEtd {\n    ...SemanticString_data\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c9171bd0456a0476ff52719c87851ed9';
export default node;
